import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api';
import { Subject, Subscription } from 'rxjs';
import { AcademyService } from 'src/app/manage/academies/service/academies.service';
import { CityService } from 'src/app/manage/city/service/city.service';
import { StateService } from 'src/app/manage/state/service/state.service';
import { BannerService } from 'src/app/services/banner.service';
import { RoleService } from 'src/app/services/role.service';
import { environment } from 'src/environments/environment';
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import {
  SwiperComponent,
  SwiperDirective,
  SwiperConfigInterface,
  SwiperScrollbarInterface,
  SwiperPaginationInterface,
} from "ngx-swiper-wrapper";

@Component({
  selector: 'app-academies',
  templateUrl: './academies.component.html',
  styleUrls: ['./academies.component.scss']
})
export class AcademiesComponent implements OnInit {
       position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';
       public downloadModal: boolean = false;
       public mobilFilter: boolean = false;
  availableClasses: string[] = ["body-dark", "body-white", "colorful"];
  currentClassIdx: number = 0;
  bodyClass: string;
  public cmsContent;
  public cmsContentData;
  public bannerList: any[];
  public webBannerImageList: any[] = [];
  public mobileBannerImageList: any[] = [];
  public cityList: any[] = [];
  public cityListData: any[] = [];
  public loading: boolean;
  public isLoadingAcademies: boolean = true;
  public isLoadingFilters: boolean = true;
  public errorMessage: string;
  public totalRecords = 0;

  public states: any[] = [];
  public statesListData: any[] = [];
  totalCityRecords: any;
  public cities: any[] = [];
  private lazyLoadEvent: LazyLoadEvent;
  public pagination = environment.pagination;
  public selectedStates: any[] = [];
  public selectedCities: any[] = [];
  academiesList: any;
  imagedata: any;
  profileimage: any;
  academyelement: any;
  imagedataa: any;
  public stateName;
  public stateCode;
  public cityCode;
  public cityName;
  public hardVal;
  public grassVal;
  public clayVal;
  pageNumberFirst: any;
  pageLimitFirst: number;
  totalAcademyRecords: any;
  isNavigatedToAcademy: boolean = false;
  searchedStateName: string = null;
  searchedCityName: string = null;
  selectedState: any = [];
  selectedCity: any = [];
  private searchSubject = new Subject<string>();
  private academySearchSubscription!: Subscription;
  academyName: string = null;
  skeletonCards: number[] = Array(6).fill(0); // For skeleton card placeholders
  activeIndex: number = 0;

  
    carouselResponsiveOptions: any[] = [
      {
        breakpoint: "1024px",
        numVisible: 12,
        numScroll: 12,
        margin: 20,
      },
      {
        breakpoint: "768px",
        numVisible: 2,
        numScroll: 2,
        margin: 20,
      },
      {
        breakpoint: "560px",
        numVisible: 1,
        numScroll: 1,
      },
    ];
  
    public show: boolean = true;
    public blogs = [];
    public slides = [
      {
        banner_image_src: "assets/img/slide/sowjanya-pic.png",
        player_name: "Sowjanya Bavisetti",
        player_location: "New Delhi",
      },
      {
        banner_image_src: "assets/img/slide/jeevan-pic.png",
        player_name: "Jeevan Nedunchezhiyan",
        player_location: "Pune",
      },
      {
        banner_image_src: "assets/img/slide/karman-pic.png",
        player_name: "Karman Kaur Thandi",
        player_location: "Bangalore",
      },
      {
        banner_image_src: "assets/img/slide/rutuja-pic.png",
        player_name: "Rutuja Bhosale",
        player_location: "Chennai",
      },
      {
        banner_image_src: "assets/img/slide/vishnuvardhan-pic.png",
        player_name: "Vishnu Vardhan",
        player_location: "French ",
      },
    ];
    public slides1: any[] = [];
  
    public config_thumbs = {
      a11y: true,
      direction: "horizontal",
      observer: true,
      spaceBetween: 10,
      slideToClickedSlide: true,
      slidesPerView: 4.5,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      simulateTouch: true,
      resistanceRatio: 0.6,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      navigation: {
        nextEl: ".carousel__arrow--prev",
        prevEl: ".carousel__arrow--next",
      },
      breakpoints: {
        // when window width is <= 1024px
        1024: {
          slidesPerView: 5.5,
        },
      },
    };
  
    public config_gallery = {
      a11y: true,
      effect: "slide",
      loop: true,
      initialSlide: 0,
      thumbs: {
        swiper: this.slides,
      },
      spaceBetween: 0,
      simulateTouch: true,
      preloadImages: false,
      observer: true,
      lazy: {
        loadPrevNext: false,
        loadOnTransitionStart: true,
      },
      zoom: {
        maxRatio: 5,
      },
    };
  
    public type: string = "component";
  
    public disabled: boolean = false;
  
    public config: SwiperConfigInterface = {
      direction: "horizontal",
      grabCursor: true,
      centeredSlides: true,
      effect: "coverflow",
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 3,
        slideShadows: true,
      },
  
      loop: false,
      keyboard: true,
      mousewheel: false,
      scrollbar: false,
      navigation: false,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 2,
        },
        1560: {
          slidesPerView: 3,
        },
        2500: {
          slidesPerView: 3,
        },
      },
    };
    public isAcademy: boolean = false;
    public Top_config: SwiperConfigInterface = {
      // speed: 400,
      speed: 5000,
      loop: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: "auto",
  
      direction: "horizontal",
      grabCursor: true,
      centeredSlides: true,
      effect: "slide",
      keyboard: true,
      mousewheel: false,
      scrollbar: false,
      navigation: false,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        992: {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 500,
        },
      },
    };
  
    public todayContest: SwiperConfigInterface = {
      speed: 300,
      loop: false,
      slidesPerView: 'auto',
      centeredSlides: false,
      effect: 'slide',
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: false,
      navigation: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        370: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        },
        993: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        },
      },
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
    };
  
    featureListSlider = {
      effect: 'slide',
      slidesPerView: 3,
      spaceBetween: 20,  // Adjust spacing as needed
      loop: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 2.15,
          spaceBetween: 10,
            autoplay:false,
        },
        400: {
          slidesPerView: 2.3,
          spaceBetween: 10,
            autoplay:false,
        },
  
        767: {
          slidesPerView: 2.3,
          spaceBetween: 0,
         
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
         
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        },
        993: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        },
      },
    };
    tournamentListSlider = {
      effect: 'slide',
      slidesPerView: 3,
      spaceBetween: 20,  // Adjust spacing as needed
      loop: false,
      // autoplay: {
      //   delay: 3000,
      //   disableOnInteraction: false
      // },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
      320: {
          slidesPerView: 1.4,
          spaceBetween: 10,
            autoplay:false,
        },
        400: {
        slidesPerView: 1.4,
          spaceBetween: 10,
            autoplay:false,
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView:2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        },
        993: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        },
      },
    };
  
    newsSlider = {
      effect: 'slide',
      slidesPerView: 3,
      spaceBetween: 20,  // Adjust spacing as needed
      loop: false,
      // autoplay: {
      //   delay: 3000,
      //   disableOnInteraction: false
      // },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
       breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        370: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView:2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        },
        993: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        },
      },
       
    };
    rewardSlider = {
      effect: 'slide',
      slidesPerView: 4,
      spaceBetween: 20,  // Adjust spacing as needed
      loop: false,
      // autoplay: {
      //   delay: 3000,
      //   disableOnInteraction: false
      // },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
         320: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        767: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        },
        993: {
          slidesPerView: 4,
          spaceBetween: 20,
          centeredSlides: false,
        },
      },
    };
    coinsRewardSlider = {
      effect: 'slide',
      slidesPerView: 3,
      spaceBetween: 20,  // Adjust spacing as needed
      loop: false,
      // autoplay: {
      //   delay: 3000,
      //   disableOnInteraction: false
      // },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
       breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        767: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        },
        993: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        },
      }, 
    };
  
    public faqSlider: SwiperConfigInterface = {
      speed: 300,
      loop: false,
      slidesPerView: 'auto',
      centeredSlides: false,
      effect: 'slide',
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: false,
      navigation: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        // renderBullet: function (index, className) {
        //   // Only show up to 5 bullets
        //   if (index < 6) {
        //     return '<span class="' + className + '"></span>';
        //   }
        //   return '';
        // },
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
      },
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
    };
  
    trackByFn(index: number, item: any): any {
      return item.id; // or any unique identifier for the contest
    }

    trackByState(index: number, item: any): any {
      return item.id || index;
    }

    trackByCity(index: number, item: any): any {
      return item.id || index;
    }

    trackByAcademy(index: number, item: any): any {
      return item.id || index;
    }

    trackByImage(index: number, item: any): any {
      return item?.slider_image_src || index;
    }
  
    onIndexChange(event: any): void {
      // Minimal logic to handle index change
    }
  
    onSwiperEvent(event: string): void {
      // Minimal logic to handle swiper events
    }
  
    public contest_config: SwiperConfigInterface = {
      direction: "horizontal",
      grabCursor: true,
      centeredSlides: false,
      effect: "slide",
  
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false
      // },
      loop: true,
      keyboard: true,
      mousewheel: false,
      scrollbar: false,
      // navigation: false,
      // navigation: {
      //   nextEl: ".contestnext",
      //   prevEl: ".contestprev",
      // },
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 0,
          centeredSlides: false,
          navigation: false,
  
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 15,
          centeredSlides: false,
          navigation: false,
  
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 15,
          centeredSlides: false,
          navigation: false,
  
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 15,
          centeredSlides: false,
          navigation: false,
  
        },
        850: {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: false,
          navigation: {
            nextEl: ".contestnext",
            prevEl: ".contestprev",
          },
        },
        851: {
          slidesPerView: 2,
          spaceBetween: 0,
          centeredSlides: false,
          navigation: {
            nextEl: ".contestnext",
            prevEl: ".contestprev",
          },
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 0,
          centeredSlides: false,
          navigation: {
            nextEl: ".contestnext",
            prevEl: ".contestprev",
          },
        },
        1199: {
          slidesPerView: 2,
          spaceBetween: 0,
          centeredSlides: false,
          navigation: {
            nextEl: ".contestnext",
            prevEl: ".contestprev",
          },
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 0,
          navigation: {
            nextEl: ".contestnext",
            prevEl: ".contestprev",
          },
        },
      },
    };
    public courtTypeList = environment.courtTypeList;
    public proplayers_config: SwiperConfigInterface = {
      speed: 400,
      loop: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
  
      direction: "horizontal",
      grabCursor: true,
      centeredSlides: false,
      effect: "slide",
      // slidesPerView: 'auto',
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false
      // },
      keyboard: true,
      mousewheel: false,
      scrollbar: false,
      navigation: false,
      //  navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev",
      //   },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        590: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
  
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    };
    public academy_config: SwiperConfigInterface = {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",
      mousewheel: false,
      loop: false,
  
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 2,
        slideShadows: false,
      },
      spaceBetween: 60,
      pagination: false,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
    };
    public product_config: SwiperConfigInterface = {
      direction: "horizontal",
      grabCursor: true,
      centeredSlides: false,
      effect: "slide",
      speed: 400,
      loop: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
  
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: false,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
  
        768: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    };
  
    public acc_config: SwiperConfigInterface = {
      direction: "horizontal",
      grabCursor: true,
      centeredSlides: true,
      effect: "coverflow",
      speed: 400,
      loop: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 2,
        slideShadows: false,
      },
      slidesPerView: "auto",
      spaceBetween: 60,
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
    };
    public news_config: SwiperConfigInterface = {
      direction: "vertical",
      grabCursor: true,
      centeredSlides: false,
      effect: "slide",
      speed: 400,
      loop: true,
      mousewheel: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      observer: true,
      observeParents: true,
  
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
      breakpoints: {
        320: {
          direction: "horizontal",
          slidesPerView: 2,
          spaceBetween: 10,
        },
        480: {
          direction: "horizontal",
          slidesPerView: 2,
          spaceBetween: 10,
        },
        767: {
          direction: "horizontal",
          slidesPerView: 2,
          spaceBetween: 15,
        },
        768: {
          direction: "vertical",
          slidesPerView: 3,
          spaceBetween: 10,
        },
        992: {
          direction: "vertical",
          slidesPerView: 3,
          spaceBetween: 10,
        },
        2500: {
          slidesPerView: 3,
          spaceBetween: 10,
          direction: "vertical",
        },
      },
    };
  
    public Newscenter_config: SwiperConfigInterface = {
      direction: "horizontal",
      grabCursor: true,
      centeredSlides: false,
      effect: "slide",
  
      speed: 400,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
  
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        992: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      },
    };
  
    public blog_config: SwiperConfigInterface = {
      direction: "horizontal",
      grabCursor: true,
      centeredSlides: false,
      effect: "slide",
  
      speed: 400,
      loop: false,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false
      // },
      mousewheel: false,
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: false,
      },
      navigation: false,
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
  
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    };
    // private scrollbar: SwiperScrollbarInterface = {
    //   el: '.swiper-scrollbar',
    //   hide: false,
    //   draggable: true
    // };
  
    // private pagination: SwiperPaginationInterface = {
    //   el: '.swiper-pagination',
    //   clickable: true,
    //   hideOnClick: false
    // };
  
    @ViewChild(SwiperComponent) componentRef?: SwiperComponent;
    @ViewChild(SwiperDirective) directiveRef?: SwiperDirective;

  constructor(private stateService: StateService,
    private bannerService: BannerService,
    private cityService: CityService,
    private academyService: AcademyService,
    private activatedRoute:ActivatedRoute,
    private roleService: RoleService,
    private route: Router) {
    this.bodyClass = this.availableClasses[this.currentClassIdx];
    this.changeBodyClass();
  }
  public config1 = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    required: true,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  changeBodyClass() {
    // get html body element
    const bodyElement = document.body;

    if (bodyElement) {


      this.currentClassIdx = this.getNextClassIdx();
      const nextClass = this.availableClasses[this.currentClassIdx];
      const activeClass = this.availableClasses[this.getPrevClassIdx()];

      // remove existing class (needed if theme is being changed)
      bodyElement.classList.remove(activeClass);
      // add next theme class
      bodyElement.classList.add(nextClass);

      this.bodyClass = nextClass;
    }
  }

  getPrevClassIdx(): number {
    return this.currentClassIdx === 0
      ? this.availableClasses.length - 1
      : this.currentClassIdx - 1;
  }

  getNextClassIdx(): number {
    return this.currentClassIdx === this.availableClasses.length - 1
      ? 0
      : this.currentClassIdx + 1;
  }
  ngOnInit(): void {
    this.roleService.setCurrentActiveRoute(this.route.url);
    this.activatedRoute.queryParams.subscribe((query)=>{
      if(query['page']) {
        this.pageNumberFirst = query['page'];
      } else {
        this.pageNumberFirst = 1;
      }
      if(query['limit']) {
        this.pageLimitFirst = +query['limit'];
      } else {
        this.pageLimitFirst = 10;
      }
    })
    this.getLocation();
    this.fetchSearchResults();
    //this.getState();
    this.getBanner();
    this.loadAcademies(this.lazyLoadEvent);
    const obj = {
      target: {
        value: ''
      }
    }
    this.onSearchState(obj);
    this.searchedStateName = null;
    this.onSearchCity(obj);
    this.searchedCityName = null;
  }

  onSearchAcademy(searchTerm: string) {
    this.searchSubject.next(searchTerm.trim());
  }

  fetchSearchResults() {
    this.academySearchSubscription = this.searchSubject
      .pipe(
        debounceTime(500),                // Wait 500ms after typing stops
        distinctUntilChanged(),            // Only trigger if query changed
      )
      .subscribe((searchTerm) => {
        if (searchTerm !== '' && searchTerm !== null) {
          this.academyName = searchTerm;
        } else {
          this.academyName = '';
        }
        this.loadAcademies(this.lazyLoadEvent);
    });
  }

  loadAcademies(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    let query = "?filterByDisable=false&filterByStatus=true";
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }

    this.activatedRoute.queryParams.subscribe(params => {
      if(event === undefined) {
        pagenumber = params['page'];
        rows = params['limit'];
      } 
      if(Object.keys(params).length === 0) {
        pagenumber = 1;
        rows = 10;
      }
    });

    if(this.isNavigatedToAcademy) {
      this.route.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { page: pagenumber,limit: rows },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }

    // alert(this.stateCode);
    // alert(this.cityName);
    if (this.academyName !== '' && this.academyName !== null) {
      query += "&filterByName=" + this.academyName;
    }
    if (this.stateName != undefined && this.stateName != "") {
      params += "&filterByStateNames=" + this.stateName;
    }
    if (this.cityName != undefined && this.cityName != "") {
      params += "&filterByCityNames=" + this.cityName;
    }

    if (this.hardVal) {
      params += "&filterByHard=" + this.hardVal;
    }
    if (this.grassVal) {
      params += "&filterByGrass=" + this.grassVal;
    }
    if (this.clayVal) {
      params += "&filterByClay=" + this.clayVal;
    }

    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;

    this.isLoadingAcademies = true;
    this.academyService.getAcademyList(query).subscribe(
      data => {
        window.scroll(0, 0);
        //console.log("xxx", data);
        this.loading = false;
        this.academiesList = data.data.items;
        this.totalAcademyRecords = data.data.totalCount;
        this.academiesList.forEach((element) => {
          this.imagedataa = element['academypic'];
        })
        this.isNavigatedToAcademy = true;
        this.isLoadingAcademies = false;
      },
      err => {
        this.errorMessage = err.error.message;
        this.isLoadingAcademies = false;
      }
    )
  }

  oncickdetails(id) {
    console.log(id);
    this.route.navigate(['academies/academydetails/' + id]);
  }

  getLocation() {
    //let query = "&filterByCountryCode=IN&filterfilterByDisable=false&orderBy=name&sortBy=1";
    this.isLoadingFilters = true;
    this.academyService.getAcademyLocation().subscribe((res) => {
      this.statesListData = JSON.parse(JSON.stringify(res.data.statelist));
      this.states = this.statesListData;
      this.cityListData = JSON.parse(JSON.stringify(res.data.citylist));
      this.cityList = this.cityListData;
      //this.states = res.data.items;
      this.isLoadingFilters = false;
    }, err => {
      this.isLoadingFilters = false;
    })
  }

  onStateSelect(event) {
    if (event.checked.length > 0) {
      this.stateCode = [...event.checked.map(ele => ele.id)];
      this.stateName = [...event.checked.map(ele => ele.name)];
    } else {
      this.stateCode = [];
      this.stateName = [];
    }
    this.loadAcademies(this.lazyLoadEvent);
  }

  onSearchState(event) {
    this.states = this.statesListData.filter(ele => ele.name.toLowerCase().includes(event.target.value.toLowerCase()));
  }

  onSearchCity(event) {
    this.cityList = this.cityListData.filter(ele => ele.name.toLowerCase().includes(event.target.value.toLowerCase()));
  }

  getState() {
    let query = "&filterByCountryCode=IN&filterfilterByDisable=false&orderBy=name&sortBy=1";
    this.stateService.getstateList(query).subscribe((res) => {
      this.states = res.data.items;
    })
  }

  setHard(event) {
    this.hardVal = event.checked;
    this.loadAcademies(this.lazyLoadEvent);
  }
  setGrass(event) {
    this.grassVal = event.checked;
    this.loadAcademies(this.lazyLoadEvent);
  }
  setClay(event) {
    this.clayVal = event.checked;
    this.loadAcademies(this.lazyLoadEvent);
  }

  setState(event) {
    if (event.value != null) {
      this.stateCode = event.value.id;
      this.stateName = event.value.name;
      //this.getCities(this.stateCode);
    }
    // else {
    //   this.cityList = [];
    //   this.stateCode = "";
    //   this.stateName = "";
    //   this.cityCode="";
    //   this.cityName="";
    // }
    this.loadAcademies(this.lazyLoadEvent);
  }
  clearState() {
    this.selectedState = [];
    this.selectedCity = [];
    this.stateCode = [];
    this.stateName = [];
    this.cityCode = [];
    this.cityName = [];
    this.grassVal = null;
    this.clayVal = null;
    this.hardVal = null;
    this.loadAcademies(this.lazyLoadEvent);
        const obj = {
      target: {
        value: ''
      }
    }
    this.onSearchState(obj);
    this.searchedStateName = null;
    this.onSearchCity(obj);
    this.searchedCityName = null;
  }
  getCities(stateId) {
    if (stateId != "") {
      this.cityList = [];
      // this.cityCode = '';
      // this.cityName = '';
      let query = "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" + stateId;
      this.cityService.getcityList(query).subscribe((res) => {
        this.loading = false;
        if (res.data.items.length > 0) {
          res.data.items.forEach(element => {
            let cityObj = {
              name: element.name,
              code: element.name,
            }
            this.cityList.push(cityObj);
          });
        }
      })
    }
  }

  onCitySelect(event) {
    if (event.checked.length > 0) {
      this.cityCode = [...event.checked.map(ele => ele.id)];
      this.cityName = [...event.checked.map(ele => ele.name)];
    } else {
      this.cityCode = [];
      this.cityName = [];
    }
    this.loadAcademies(this.lazyLoadEvent);
  }

  clearCity() {
    this.cityCode = "";
    this.cityName = "";
    this.loadAcademies(this.lazyLoadEvent);
  }
  onClickState(event) {
    if (event.value != null) {
      let state = event.value;
      this.selectedStates = state.name;
    } else {
      this.selectedStates = [];
    }
  }

  onClickCity(event) {
    if (event.value != null) {
      let city = event.value;
      this.selectedCities = city.name;
    } else {
      this.selectedCities = [];
    }
  }

  getBanner() {
    let query = "?filterByDisable=false&filterByStatus=true&filterBySlug=academies";
    this.bannerService.getbannerList(query).subscribe(
      data => {
        this.loading = false;
        this.bannerList = data.data.items;
        this.totalRecords = data.data.totalCount;
        this.bannerList.forEach(element => {
          this.webBannerImageList = element.banner_image;
          this.mobileBannerImageList = element.mobile_banner_image;
        });
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  onDownloadClick(position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright'){
  this.position = position;
  this.downloadModal = true; 
}
  showMobileFilter() {
      this.mobilFilter = true;
     }
}
